import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `org`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'access',
  permission: 'users.manage',
} satisfies AdminPageAccessRule;
